import React from 'react';
import Delivery from '.';
import { AccordionContext } from '@/generic-components/checkout/accordion';
import BypassIfComplete from '@/generic-components/checkout/accordion/bypass-if-complete';
import { AccordionSectionContext } from '@/generic-components/checkout/accordion/section';
import { CheckoutContext } from '../accordion';

export interface ICompleteSection {
  completeSection: (summary: any) => void;
}
const DeliveryWrapper = () => {
  return (
    <CheckoutContext.Consumer>
      {({ basket, checkoutCms, ecProducts }) => (
        <AccordionContext.Consumer>
          {({ neverBypassActiveSection }) => (
            <AccordionSectionContext.Consumer>
              {({ completeSection }) => (
                <BypassIfComplete
                  onBypass={completeSection}
                  isComplete={false} // Need to look further
                  neverBypass={neverBypassActiveSection}
                >
                  <Delivery
                    basket={basket}
                    setActiveSection={completeSection}
                    checkoutCms={checkoutCms}
                    ecProducts={ecProducts}
                  />
                </BypassIfComplete>
              )}
            </AccordionSectionContext.Consumer>
          )}
        </AccordionContext.Consumer>
      )}
    </CheckoutContext.Consumer>
  );
};

export default DeliveryWrapper;
